<template>
  <div class="contact-us">
    <el-carousel height="410px" class="swImg" arrow="never">
      <el-carousel-item v-for="(item, index) in imgList" :key="index" class="pointer">
        <img style="height: 100%;" :src="item.img" @click="nav(item)" />
      </el-carousel-item>
    </el-carousel>
    <div class="con">
      <div class="zr">
        <img style="width: 14px;height: 14px;margin-right: 4px;"
          src="https://staticfile.xlcwx.com/m-images/yth/lzimg/careerpc/x13.png" alt="">
        首页 > 联系我们
      </div>
      <div class="ti">联系我们</div>
      <div class="ti1">CONTACT US</div>
      <div class="cc">

        <div class="contact-info">
          <div class="aa">
            <img style="height: 54px;" :src="logo" alt="">
          </div>

          <div class="contact-item">
            <img style="width: 22px;height: 22px;margin-right: 4px;"
              src="https://staticfile.xlcwx.com/m-images/yth/lzimg/careerpc/x23.png" alt="">
            <span>联  &nbsp;系&nbsp;   人</span>
            <div>{{ members.userName }}</div>
          </div>
          <div class="contact-item">
            <img style="width: 22px;height: 22px;margin-right: 4px;"
              src="https://staticfile.xlcwx.com/m-images/yth/lzimg/careerpc/x22.png" alt="">
            <span>联系电话</span>
            <div>{{ members.mobile }}</div>
          </div>
          <div class="contact-item">
            <img style="width: 22px;height: 22px;margin-right: 4px;"
              src="https://staticfile.xlcwx.com/m-images/yth/lzimg/careerpc/x21.png" alt="">
            <span>联系地址</span>
            <div>{{ members.address }}</div>
          </div>
          <div class="contact-item">
            <img style="width: 22px;height: 22px;margin-right: 4px;"
              src="https://staticfile.xlcwx.com/m-images/yth/lzimg/careerpc/x20.png" alt="">
            <span>联系邮箱</span>
            <div>{{ members.mail }}</div>
          </div>
        </div>
        <div class="sc">
          <img :src="members.imgUrl" alt="">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getDomain, getDomainLogo } from '@/api/cookies'
import { HomeClient } from '@/api/home'
const homeClient = new HomeClient()
export default {
  name: "ContactUs",
  data() {
    return {
      members: {},
      logo: '',
      imgList: [],
      infoDomain: {}
    };
  },
  created() { 
    this.infoDomain = getDomain() || {}
    this.getList()
    this.logo = getDomainLogo() 


  },
  methods: {

    async getList() {
      await Promise.all([
        homeClient.getContactInfo().then((res) => {
          const data = res.data || {}
          // 将联系信息字段适配为原模板字段，空字符串表示清空配置。
          this.members = {
            ...data,
            userName: data.contactName !== undefined ? data.contactName : data.userName,
            address: data.contactAddress !== undefined ? data.contactAddress : data.address,
            mobile: data.contactPhone !== undefined ? data.contactPhone : data.mobile,
            mail: data.contactEmail !== undefined ? data.contactEmail : data.mail,
            imgUrl: data.backgroundUrl !== undefined ? data.backgroundUrl : data.imgUrl,
          }
        }),
        homeClient.getSurfacePcList({ type: 12, entrantsType: this.infoDomain.entrantsType }).then((res) => {
          if (res.code == 0) {
            this.imgList = res.data || [];
          }
        }),
      ]);
    }
  }
};
</script>

<style lang="less" scoped>
.con {
  width: 1400px;
  margin: 0 auto;

  .zr {

    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #999999;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin-top: 26px;
  }

  .ti {

    font-family: PingFang SC, PingFang SC;
    font-weight: bold;
    font-size: 34px;
    color: #333333;
    text-align: center;
    margin-top: 8px;
  }

  .ti1 {
    text-align: center;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 18px;
    color: #989898;
    margin-top: 2px;
  }

  .cc {
    display: flex;
    align-items: center;
    position: relative;
    width: 1400px;
    margin-top: 40px;
    height: 460px;

    .contact-info {

      width: 888px;
      height: 360px;
      background: #FFFFFF;
      border-radius: 0px 0px 0px 0px;
      // opacity: 0.94;
      display: flex;
      flex-direction: column;
      justify-content: center;
      padding-left: 74px;
      position: relative;
      z-index: 99;
      margin-top: 20px;

      .aa {
        width: fit-content;
        height: 82px;
        padding: 14px 20px;
        background: #1D7DF5;
        border-radius: 0px 0px 0px 25px;
        position: absolute;
        top: 0;
        right: 0;

      }

      .contact-item {
        display: flex;
        align-items: center;
        margin-bottom: 30px;

        span {
width: 78px;
          font-family: PingFang SC, PingFang SC;
          font-weight: 400;
          font-size: 18px;
          color: #1D7DF5;
          margin-right: 16px; 
        }

        >div {

          font-family: PingFang SC, PingFang SC;
          font-weight: bold;
          font-size: 18px;
          color: #333333;
        }

        &:last-child {
          margin-bottom: 0;
        }
      }
    }

    .sc {
      width: 947px;
      height: 443px;
      border-radius: 40px 0 0 40px;
      overflow: hidden;
      position: absolute;
      right: 0;

      img {
        display: block;
        width: 947px;
        height: 443px;
        border-radius: 40px 0 0 40px;
      }
    }
  }
}
.swImg{
  width: 100%;
}
</style>
